module.exports = __webpack_public_path__ + "img/gradeB.11c7bca7.png";